module.exports = __webpack_public_path__ + "static/media/levicaLogo.2d6ced58.svg";